import useAdvancedSearchNextURL from './useAdvancedSearchNextURL';

/**
 * Resolves advanced-search URL state using next/navigation hooks.
 */
const useAdvancedSearchURL = useAdvancedSearchNextURL;

export default useAdvancedSearchURL;
